document.addEventListener("DOMContentLoaded", function () {
    // Управления формсетами
    class FormsetManager {
        constructor() {
            this.translations = window.formTranslations;
            this.formsetContainer = this.getElementSafely("attach-formset");
            this.dynamicFormsContainer = this.formsetContainer;

            this.formsContainer = this.formsetContainer; // Используем тот же контейнер
            this.totalForms = this.getElementSafely("id_attach_set-TOTAL_FORMS");
            this.addFileButton = this.getElementSafely("add-file");
            this.addVideoButton = this.getElementSafely("add-video");
            
            if (!this.validateElements()) return;
            
            this.templateForm = this.formsetContainer.querySelector('.attach-form');
            this.formCount = this.totalForms ? parseInt(this.totalForms.value) : 0;
            this.init();
        }

        //! Вспомогательные методы
        getElementSafely(id, errorMessage = null) {
            const element = document.getElementById(id);
            if (!element && errorMessage) {
                console.debug(errorMessage);
            }
            return element;
        }
        
        //! Есть ли выбранные элементы
        validateElements() {
             return this.formsetContainer && 
                    this.dynamicFormsContainer &&         
                    this.addFileButton && 
                    this.addVideoButton && 
                    this.totalForms;
        }

        init() {
            //! Скрываем только пустые формы при загрузке
            this.hideEmptyForms();

            //! Настройка обработчиков событий
            this.setupEventListeners();
            
            // метод для обработки существующих форм
            this.processExistingForms(); 

            // Если есть существующие формы (при редактировании)
            const existingForms = this.formsetContainer.querySelectorAll('.attach-form[style="display: block"], .attach-form:not([style])');
            if (existingForms.length > 0) {
                existingForms.forEach(form => {
                    this.dynamicFormsContainer.appendChild(form);
                    this.addCancelButton(form);
                });
                this.formCount = existingForms.length;
                this.totalForms.value = this.formCount;
            }
        }

        //! метод для обработки существующих форм
        processExistingForms() {
            const forms = this.formsetContainer.querySelectorAll('.attach-form');
            
            forms.forEach(form => {
                // Проверяем, заполнена ли форма
                const isFilled = this.isFormFilled(form);
                
                // Для заполненных форм скрываем пустые поля
                if (isFilled) {
                    this.hideEmptyFields(form);
                }
                
                // Для новых форм (пустых) оставляем все как есть
            });
        }
        isFormFilled(form) {
            // Проверяем, есть ли хотя бы одно заполненное поле (кроме скрытых)
            return Array.from(form.querySelectorAll('input:not([type="hidden"]), textarea, select'))
                .some(input => {
                    if (input.type === 'file') {
                        // Для файлов проверяем наличие текущего файла
                        const currentFile = form.querySelector('a[href*="/media/"]');
                        return currentFile || input.files.length > 0;
                    }
                    if (input.type === 'checkbox' || input.type === 'radio') {
                        return input.checked;
                    }
                    return input.value && !input.name.includes('DELETE') && !input.name.includes('-clear');
                });
        }
        hideEmptyFields(form) {
            // Проверяем поле PDF
            const pdfField = form.querySelector('[name*="pdf"]');
            const pdfCurrent = form.querySelector('a[href*="/media/"]');
            if (pdfField && !pdfCurrent && !pdfField.files.length) {
                pdfField.closest('.mb-3').style.display = 'none';
            }
            
            // Проверяем поле YouTube
            const youtubeField = form.querySelector('[name*="youtube"]');
            if (youtubeField && !youtubeField.value) {
                youtubeField.closest('.mb-3').style.display = 'none';
            }
        }

        //! Скрываем только пустые формы при загрузке
        hideEmptyForms(count) {
            const forms = this.formsetContainer.querySelectorAll('.attach-form');
            forms.forEach((form, index) => {
                // Проверяем, заполнена ли форма
                const isFilled = Array.from(form.querySelectorAll('input, textarea, select'))
                    .some(input => {
                        if (input.type === 'file') return false; // Файлы не учитываем
                        if (input.type === 'checkbox' || input.type === 'radio') return input.checked;
                        
                        return input.value && !input.name.includes('DELETE') && !input.name.includes(`attach_set-${index}-post`);
                    });
                
                // Скрываем только пустые формы
                if (!isFilled) {
                    form.style.display = 'none';
                }
            });
        }
        //! Обработчики событий
        setupEventListeners() {
            this.addFileButton.addEventListener("click", () => this.addForm('file'));
            this.addVideoButton.addEventListener("click", () => this.addForm('video'));
            
            // Делегированная обработка кнопок удаления
            this.formsContainer.addEventListener("click", (e) => {
                if (e.target.closest(".cancel-clone-btn")) {
                    this.handleCancelClick(e.target.closest(".cancel-clone-btn"));
                }
            });
            
            // Валидация YouTube URL
            document.addEventListener("input", e => {
                if (e.target?.name?.includes("youtube")) {
                    this.validateYouTubeUrls();
                }
            });
            
            // Обработка отправки формы
            const postForm = document.getElementById("post-form");
            postForm?.addEventListener("submit", e => {
                if (!this.validateYouTubeUrls()) {
                    e.preventDefault();
                    this.scrollToFirstError();
                }
            });
        }

        //! Добавляем форму
        addForm(type) {
            // Проверяем, есть ли скрытая форма с индексом 0
            const firstForm = document.getElementById('attach-form-0');
            // const hiddenForm = this.formsetContainer.querySelector('#attach-form-0[style="display: none;"]');
            
            // if (hiddenForm && this.formCount === 0) {
            if (firstForm && firstForm.style.display === 'none' && this.formCount === 0) {
                firstForm.style.display = 'block';
                this.prepareCleanForm(firstForm, type);
                this.addCancelButton(firstForm);
                // this.dynamicFormsContainer.appendChild(hiddenForm);
            } else {
                if (!this.templateForm) {
                    console.error("Не найдена форма для клонирования");
                    return;
                }
                
                // Клонируем форму
                const template = this.formsetContainer.querySelector('.attach-form');
                const newForm = template.cloneNode(true);
                // const newForm = this.templateForm.cloneNode(true);
                newForm.style.display = 'block';

                // Генерируем новый ID
                const newId = `attach-form-${this.formCount}`;
                newForm.id = newId;
                
                // После добавления/активации формы скрываем ненужные поля
                const form = firstForm || newForm;
                this.hideEmptyFields(form);
                
                //! Очищаем и настраиваем поля в зависимости от типа
                this.prepareCleanForm(newForm, type);
                //! Обновляем атрибуты формы
                this.updateFormAttributes(newForm, this.formCount);
                //! Добавляем кнопку удаления
                this.addCancelButton(newForm);

                // Удаляем чекбокс DELETE, если он есть
                const deleteCheckbox = newForm.querySelector('input[name*="-DELETE"]');
                if (deleteCheckbox) {
                    deleteCheckbox.closest('.form-check')?.remove();
                }

                // this.formsetContainer.insertBefore(newForm, this.addFileButton);
                this.dynamicFormsContainer.appendChild(newForm);
            }
            //! Обновляем счетчик форм
            this.incrementFormCount();
        }

        //! Очищаем и настраиваем поля в зависимости от типа
        prepareCleanForm(form, type) {
            // Очищаем только новые формы (не attach-form-0)
            if (!form.id.startsWith('attach-form-0')) {
                form.querySelectorAll('input:not([type="hidden"]), textarea, select').forEach((input) => {
                    if (!input.name.includes("DELETE")) {
                        input.value = "";
                        if (input.type === "checkbox" || input.type === "radio") {
                            input.checked = false;
                        }
                    }
                });
            }

            // Сброс файловых полей
            this.resetFileInputs(form);

            // Удаляем сообщения об ошибках
            form.querySelectorAll('.errorlist, .invalid-feedback').forEach(el => el.remove());
            
            // Скрываем ненужные поля в зависимости от типа
            if (type === 'file') {
                form.querySelector('[name*="youtube"]').closest('.mb-3').style.display = 'none';
                form.querySelector('[name*="pdf"]').closest('.mb-3').style.display = '';
            } else {
                form.querySelector('[name*="pdf"]').closest('.mb-3').style.display = 'none';
                form.querySelector('[name*="youtube"]').closest('.mb-3').style.display = '';
            }
        }

        //! Обновляем аттрибуты со счетчиком
        updateFormAttributes(form, count) {
            // form.id = `attach-form-${count}`;

            const attributes = ["name", "id", "for", "data-target", "aria-labelledby"];

            form.querySelectorAll("*").forEach((el) => {
                attributes.forEach((attr) => {
                    if (el.hasAttribute(attr)) {
                        const value = el.getAttribute(attr);
                        if (value) {
                            el.setAttribute(attr, value.replace(/attach_set-\d+-/, `attach_set-${count}-`));
                        }
                    }
                });

                if ("htmlFor" in el) {
                    el.htmlFor = el.htmlFor.replace(/attach_set-\d+-/, `attach_set-${count}-`);
                }
            });
        }

        //! Добавляем кнопку только к последней форме (если это не первая форма)
        addCancelButton(formElement) {
            //! Удаляем старую кнопку удаления, если есть
            const oldButton = formElement.querySelector('.cancel-clone-btn');
            if (oldButton) oldButton.remove();

            // Не добавляем кнопку к первой форме
            if (formElement.id === 'attach-form-0') return;

            // Проверяем, заполнена ли форма (при редактировании)
            if (this.isFormFilled(formElement)) {
                return; // Не добавляем кнопку для заполненных форм
            }

            //! Создаем кнопку
            const cancelBtn = document.createElement("button");
            cancelBtn.type = "button";
            cancelBtn.className = "btn btn-sm btn-outline-danger mt-2 cancel-clone-btn";
            cancelBtn.innerHTML = `<i class="fi-x"></i> ${window.formTranslations.cancel_addition}`;

            // Создаем футер формы
            const formFooter = document.createElement("div");
            formFooter.className = "form-footer text-end";
            formFooter.appendChild(cancelBtn);
            // Добавляем футер к форме
            formElement.appendChild(formFooter);
        }
        //! Переименованный метод для ясности
        updateCancelButtonOnLastForm() {
            const forms = document.querySelectorAll(".attach-form");
            if (forms.length > 0) {
                // Удаляем все кнопки отмены
                document.querySelectorAll(".cancel-clone-btn").forEach((btn) => btn.remove());
                // Добавляем кнопку только к последней форме (если это не первая форма)
                if (forms.length > 1) {
                    this.addCancelButton(forms[forms.length - 1]);
                }
            }
        }

        //! Обновляем счетчик форм
        incrementFormCount() {
            this.formCount++;
            if (this.totalForms) {
                this.totalForms.value = this.formCount;
            }
        }
        decrementFormCount() {
            this.formCount--;
            if (this.totalForms) {
                this.totalForms.value = this.formCount;
            }
        }

        //! Делегированная обработка кнопок удаления
        handleCancelClick(button) {
            const form = button.closest(".attach-form");
            const forms = Array.from(this.formsetContainer.querySelectorAll(".attach-form"))
                .filter(f => f.style.display !== 'none');

            // Проверка на первую форму
            if (forms.length <= 1) {
                alert(this.translations.cant_remove_first);
                return;
            }
            
            // Проверка на последнюю форму
            if (forms[forms.length - 1] !== form) {
                alert(this.translations.remove_only_last);
                return;
            }

            if (confirm(this.translations.confirm_remove)) {
                form.remove();
                this.decrementFormCount();
                // this.updateCancelButtonOnLastForm(); // Переименованный метод
            }
        }

        //! Сброс файловых полей
        resetFileInputs(form) {
            form.querySelectorAll('input[type="file"]').forEach((input) => {
                try {
                    const newInput = input.cloneNode(true);
                    input.replaceWith(newInput);
                    this.initFileInputHandlers(newInput);
                } catch (error) {
                    console.debug("File input reset error:", error);
                }
            });
        }
        //! Drag and Drop
        initFileInputHandlers(input) {
            if (!input) return;

            const events = {
                dragenter: this.highlight,
                dragover: this.highlight,
                dragleave: this.unhighlight,
                drop: this.unhighlight,
            };

            Object.entries(events).forEach(([event, handler]) => {
                input.removeEventListener(event, handler);
                input.addEventListener(event, handler.bind(this));
            });
        }

        //! переход к первой ошибке
        scrollToFirstError() {
            const firstError = document.querySelector(".is-invalid");
            firstError?.scrollIntoView({ behavior: "smooth", block: "center" });
        }

        //! Подсветка ошибок
        highlight(e) {
            e.preventDefault();
            e.stopPropagation();
            const form = e.target.closest(".attach-form");
            form?.classList.add("border-primary", "bg-light");
        }
        unhighlight(e) {
            e.preventDefault();
            e.stopPropagation();
            const form = e.target.closest(".attach-form");
            form?.classList.remove("border-primary", "bg-light");
        }

        //! Валидация ссылки youtube
        validateYouTubeUrls() {
            const youtubeRegex = /(youtube\.com|youtu\.be)/i;
            let isValid = true;

            document.querySelectorAll('input[name*="youtube"]').forEach((input) => {
                const url = input.value.trim();
                const hasError = url && !youtubeRegex.test(url);

                this.clearValidationErrors(input);

                if (hasError) {
                    isValid = false;
                    this.showValidationError(input);
                }
            });

            return isValid;
        }
        clearValidationErrors(input) {
            input.classList.remove("is-invalid");
            input.parentNode.querySelectorAll(".youtube-error").forEach((el) => el.remove());
        }
        showValidationError(input) {
            input.classList.add("is-invalid");

            const errorDiv = document.createElement("div");
            errorDiv.className = "invalid-feedback youtube-error";
            errorDiv.textContent = "Допускаются только ссылки с YouTube";
            input.parentNode.appendChild(errorDiv);
        }
    }
    // Инициализация менеджера форм
    new FormsetManager();
});
